import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, FeatureState } from './page-screen.reducer';

const featureSelector = createFeatureSelector<FeatureState>(featureKey);

export const selectSimplePages = createSelector(featureSelector, (s) => s.pages);

export const selectSimplePagesLoading = createSelector(featureSelector, (s) => s.loading);

export const selectAlreadyUsedGenres = createSelector(featureSelector, (s) => s.pages.genrePages.map((genrePage) => genrePage.genre));
